<template>
  <div class="header__container">
    <h2 class="header__title">{{ title }}</h2>
  </div>
</template>
<script>
export default {
  name: 'header-simple',
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss">
.header__container {
  flex: 0 0 60px;
  position: relative;
  background-color: #12698d;
  color: $mds-color-white;
}

.header__title {
  margin-left: $mds-space-2-x;
  @include mds-level-5-heading();
}
</style>
